import type { CopyModule } from 'types/capi/modules';

import Content from '~/components/Content';
import Image from '~/components/Image';

export default function ContentBlock({ module }: { module: CopyModule }) {
  return (
    <div className="bg-grey-panel">
      <div className="flex flex-col gap-6 px-4 py-16 md:mx-auto md:max-w-desktop md:px-8 desktop:px-0">
        <Image src={module.logo.url} {...module.logo} />
        <Content content={module.content} />
      </div>
    </div>
  );
}
